












































































































































































import Vue from "vue"
import { vueWith } from "./../vueWith"
import { MENU_MAP, NOTICE_NAME, NOTICE_URL, NOTICE_SERVICE, SERVICE_NAME_HTML_MAP } from "../../utils/Const"
import { NoticeSettingService } from "../../service/NoticeSettingService"

export default vueWith<{
  // $refs: { table: TableComponentMethods },
}>().extend({
  components: {
    // TableComponent,
  },
  props: {
    initValue: String,
  },
  data() {
    return {
      /** 経営レコメンド */
      adminSubmenu1: [] as any,
      /** 販促レコメンド */
      adminSubmenu2: [] as any,
      /** 在庫レコメンド */
      adminSubmenu3: [] as any,
      /** 労務レコメンド */
      adminSubmenu4: [] as any,
      /** その他レコメンド */
      adminSubmenu99: [] as any,

      username: "",
      service: 0,
      isAdmin: false,

      hiddenManual: true,

      /** 初期化済みか */
      isInitialized: false,

    }
  },

  computed: {
  },

  /** Vue構築完了時の処理 */
  mounted: function init() {

    // console.log(document.cookie)
    const cookies = decodeURI(document.cookie).split(";")
    for (let cookie of cookies) {
      // 先頭の空白除去
      cookie = cookie.replace(/^\s+/, "")
      const tmp = cookie.split("=")
      if (tmp[0] === "username") {
        this.username = tmp[1]
      }
      if (tmp[0] === "service") {
        this.service = Number(tmp[1])
      }
      if (tmp[0] === "auth") {
        this.isAdmin = tmp[1] === "1"
      }
    }


    // 管理用設定画面
    if (this.isAdmin) {
      MENU_MAP.forEach((menu) => {
        if (location.pathname.indexOf("manual") === -1) {
          // 契約対象なら表示
          // 1:商 2:蔵 3：商蔵両方 7：総務人事
          // 複数必須判定に===が必要
          // 複数機能のうちのどれかが必要な場合はビットを反転して排他的論理和を取ってAnd
          // if ((menu.service & Number(this.service)) === menu.service || (menu.service ^ Number(this.service)) && ~menu.service) {
          if (NoticeSettingService.canUseService(menu.service, this.service)) {
            switch (menu.menuGroup) {
              case 1: // 経営
                this.adminSubmenu1.push({ url: menu.url, title: menu.title, service: SERVICE_NAME_HTML_MAP(menu.service) })
                break
              case 2: // 販促
                this.adminSubmenu2.push({ url: menu.url, title: menu.title, service: SERVICE_NAME_HTML_MAP(menu.service) })
                break
              case 3: // 在庫
                this.adminSubmenu3.push({ url: menu.url, title: menu.title, service: SERVICE_NAME_HTML_MAP(menu.service) })
                break
              case 4: // 労務
                this.adminSubmenu4.push({ url: menu.url, title: menu.title, service: SERVICE_NAME_HTML_MAP(menu.service) })
                break
              case 99: // その他
                this.adminSubmenu99.push({ url: menu.url, title: menu.title, service: SERVICE_NAME_HTML_MAP(menu.service) })
                break
              default:
                break
            }
          }
        } else {
          // マニュアル用メニュー
          this.hiddenManual = false
          switch (menu.menuGroup) {
            case 1: // 経営
              this.adminSubmenu1.push({ url: "/manual" + menu.url, title: "マニュアル-" + menu.title, service: SERVICE_NAME_HTML_MAP(menu.service) })
              break
            case 2: // 販促
              this.adminSubmenu2.push({ url: "/manual" + menu.url, title: "マニュアル-" + menu.title, service: SERVICE_NAME_HTML_MAP(menu.service) })
              break
            case 3: // 在庫
              this.adminSubmenu3.push({ url: "/manual" + menu.url, title: "マニュアル-" + menu.title, service: SERVICE_NAME_HTML_MAP(menu.service) })
              break
            case 4: // 労務
              this.adminSubmenu4.push({ url: "/manual" + menu.url, title: "マニュアル-" + menu.title, service: SERVICE_NAME_HTML_MAP(menu.service) })
              break
            case 99: // その他
              this.adminSubmenu99.push({ url: "/manual" + menu.url, title: "マニュアル-" + menu.title, service: SERVICE_NAME_HTML_MAP(menu.service) })
              break
            default:
              break
          }
        }
      })
    } else {
      MENU_MAP.forEach((menu) => {
        // マニュアル用メニュー
        this.hiddenManual = false
        switch (menu.menuGroup) {
          case 1: // 経営
            this.adminSubmenu1.push({ url: "/manual" + menu.url, title: "マニュアル-" + menu.title, service: SERVICE_NAME_HTML_MAP(menu.service) })
            break
          case 2: // 販促
            this.adminSubmenu2.push({ url: "/manual" + menu.url, title: "マニュアル-" + menu.title, service: SERVICE_NAME_HTML_MAP(menu.service) })
            break
          case 3: // 在庫
            this.adminSubmenu3.push({ url: "/manual" + menu.url, title: "マニュアル-" + menu.title, service: SERVICE_NAME_HTML_MAP(menu.service) })
            break
          case 4: // 労務
            this.adminSubmenu4.push({ url: "/manual" + menu.url, title: "マニュアル-" + menu.title, service: SERVICE_NAME_HTML_MAP(menu.service) })
            break
          case 99: // その他
            this.adminSubmenu99.push({ url: "/manual" + menu.url, title: "マニュアル-" + menu.title, service: SERVICE_NAME_HTML_MAP(menu.service) })
            break
          default:
            break
        }
      })
    }

    // サブメニューに対応するグループをオープン済みにする
    this.adminSubmenu1.forEach((menu: any) => {
      if (location.pathname.indexOf(menu.url) !== -1) {
        (document.getElementById("group1") as HTMLInputElement).checked = true
      }
    })
    this.adminSubmenu2.forEach((menu: any) => {
      if (location.pathname.indexOf(menu.url) !== -1) {
        (document.getElementById("group2") as HTMLInputElement).checked = true
      }
    })
    this.adminSubmenu3.forEach((menu: any) => {
      if (location.pathname.indexOf(menu.url) !== -1) {
        (document.getElementById("group3") as HTMLInputElement).checked = true
      }
    })
    this.adminSubmenu4.forEach((menu: any) => {
      if (location.pathname.indexOf(menu.url) !== -1) {
        (document.getElementById("group4") as HTMLInputElement).checked = true
      }
    })
    this.adminSubmenu99.forEach((menu: any) => {
      if (location.pathname.indexOf(menu.url) !== -1) {
        (document.getElementById("group99") as HTMLInputElement).checked = true
      }
    })

    if (location.pathname.indexOf("manual") === -1) {
      window.addEventListener("keyup", (keyEvent) => {
        const inputKeyCode = keyEvent.key
        switch (inputKeyCode) {
          case "F1":
            location.href = "start"
            break
          case "F2":
            location.href = "dashboard"
            break
          case "F3":
            location.href = "member"
            break
          case "F4":
            location.href = "companyinfo"
            break
          default:
            break
        }
      })
    }
  },

  methods: {

    // 子から呼ばれる ---------------------------------------------

  },
})


